import AdSlot from './components/AdSlot';
const BottomAds = () => {
    return (
        <div className="homepage_bottom_ads">
            <AdSlot
                slotKey="homepage_bottom_ad"
                containerClass="homepage_bottom_ad"
                className="homepage_bottom_ad_image"
                id="homepage_bottom_ad"
            />
        </div>
    );
};

const HomePageBottomResAds = () => {
    return (
        <AdSlot
            slotKey="homepage_mobile_responsive"
            containerClass="homepage_mobile_responsive"
            className="homepage_mobile_responsive_image"
            id="homepage_mobile_responsive"
        />
    );
};

export { BottomAds, HomePageBottomResAds };
